// This is all just placeholder for now in case we need to rig up translation later
export default {
  install(app) {
    this.app = app;
    app.config.globalProperties.$t = this;
  },
  get: function(msg) {
    return msg;
  },
  getCurrentLanguage: function() {
    return 'nb';
  }
}